export default __webpack_public_path__ + "static/media/lovecraftiana-vol-7.39479d56.jpg";